export default __webpack_public_path__ + "static/media/img-new-home-1-new.af1b844f.png";